function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.0907 117.699C97.9793 117.699 143.228 89.9837 161.584 50.7809V39.4084C148.444 38.6136 137.637 25.5842 134.782 13.1006H38.2182C35.3553 25.5842 24.5561 38.6097 11.4121 39.4084V113.828C22.1282 116.351 33.4177 117.699 45.0907 117.699Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.121 0H30.879C27.5811 14.358 15.137 29.3803 0 30.2977V118.704C0 162.924 35.8416 198.778 80.0545 198.778H92.9336C137.154 198.778 173 162.924 173 118.704V30.2977C157.863 29.3803 145.419 14.358 142.117 0H142.121Z",
  fill: "url(#paint0_linear_1_172)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.476 4.72537H33.5284C30.3847 18.4072 18.5377 32.7099 4.11245 33.5798V117.786C4.11245 159.899 38.2458 194.037 80.3629 194.037H92.6371C134.75 194.037 168.884 159.899 168.884 117.786V33.5798C154.466 32.7099 142.611 18.4032 139.476 4.72537Z",
  fill: "url(#paint1_linear_1_172)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M139.476 4.72538C142.611 18.4072 154.466 32.7099 168.884 33.5798V117.786C168.884 159.899 134.75 194.037 92.637 194.037H80.3629C38.2458 194.037 4.11246 159.899 4.11246 117.786V33.5798C18.5377 32.7099 30.3808 18.4033 33.5284 4.72538H139.476ZM139.476 4.36554H33.5284C33.3584 4.36554 33.212 4.47626 33.1844 4.64234C30.1079 18.0078 18.3874 32.3579 4.08478 33.216C3.89893 33.2279 3.75262 33.39 3.75262 33.5798V117.786C3.75262 160.026 38.1233 194.397 80.3629 194.397H92.637C134.881 194.397 169.243 160.026 169.243 117.786V33.5798C169.243 33.39 169.093 33.2279 168.903 33.216C154.605 32.3579 142.892 18.0118 139.824 4.64234C139.78 4.47626 139.642 4.36554 139.472 4.36554H139.476Z",
  fill: "url(#paint2_linear_1_172)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.782 13.1084H38.2182C35.3553 25.5921 24.5561 38.6175 11.4121 39.4163V116.161C11.4121 154.537 42.5283 185.654 80.9086 185.654H92.0874C130.472 185.654 161.58 154.537 161.58 116.161V39.4124C148.44 38.6175 137.633 25.5882 134.778 13.1045L134.782 13.1084Z",
  fill: "url(#paint3_radial_1_172)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6558 59.9153L48.4123 59.7334H61.1609H86.6779H112.203H124.959L137.716 59.9153L124.959 60.1051H112.203H86.6779H61.1609H48.4123L35.6558 59.9153Z",
  fill: "url(#paint4_linear_1_172)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M87.6191 174.542C87.5756 174.499 87.54 174.431 87.5044 174.364C87.4965 174.416 87.4767 174.483 87.4609 174.526C87.0378 175.598 86.0057 174.182 85.8989 173.676C85.5589 172.225 86.4881 170.497 86.7452 169.054C86.7452 169.038 86.7531 169.018 86.7531 169.002C86.7531 169.002 86.757 169.054 86.7847 169.145C87.0734 170.311 88.1292 171.114 88.6116 172.193C88.8647 172.763 88.9437 173.352 88.7263 173.969C88.5483 174.479 88.1015 175.175 87.6191 174.55V174.542Z",
  fill: "url(#paint5_linear_1_172)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9267 161.857C79.062 161.442 81.4029 161.05 83.2773 162.007C84.1828 162.454 84.8669 163.284 85.1437 164.221C85.4482 165.178 85.3374 166.207 84.8827 167.065C84.4438 167.903 83.6292 168.563 82.7988 168.694C82.004 168.844 81.0787 168.464 80.6793 167.824C80.4776 167.547 80.355 167.025 80.3985 166.725C80.4262 166.392 80.6437 166.127 81.0391 165.942C81.4267 165.768 81.9447 165.732 82.3836 165.87C82.8304 165.985 83.1824 166.345 83.123 166.899L83.2496 166.942C83.6055 166.412 83.2377 165.59 82.6564 165.281C82.091 164.965 81.4346 164.87 80.7584 165C80.098 165.095 79.3704 165.665 79.1846 166.452C79.1174 166.638 79.1055 166.816 79.1055 166.997C79.1055 167.179 79.0976 167.365 79.149 167.523C79.2123 167.844 79.2716 168.2 79.4574 168.54C80.2048 169.821 81.7232 170.39 83.0954 170.05C84.4319 169.694 85.4047 168.69 85.899 167.547C86.4011 166.408 86.4526 165.08 86.0136 163.933C85.5826 162.774 84.6692 161.833 83.562 161.366C81.2922 160.481 78.9829 161.137 76.895 161.722L76.9227 161.857H76.9267Z",
  fill: "url(#paint6_linear_1_172)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M78.3858 164.324C77.5317 164.447 76.7171 164.676 75.9262 164.993C75.5308 165.159 75.0642 165.246 74.7676 165.578C74.4671 165.918 74.2219 166.325 74.1864 166.891L74.2813 166.986C74.8428 166.986 75.2224 166.871 75.598 166.721C75.9658 166.578 76.1793 166.214 76.4957 165.965C77.1125 165.459 77.761 164.945 78.4372 164.459L78.3858 164.324Z",
  fill: "url(#paint7_linear_1_172)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M77.8045 163.656C76.468 163.64 75.1393 163.798 73.8265 164.115C73.1662 164.265 72.4583 164.36 71.885 164.747C71.2997 165.123 70.7699 165.609 70.4456 166.294L70.5247 166.412C71.28 166.369 71.885 166.199 72.4939 166.009C73.095 165.847 73.6011 165.432 74.1903 165.178C75.3568 164.649 76.5668 164.186 77.8204 163.798L77.8124 163.656H77.8045Z",
  fill: "url(#paint8_linear_1_172)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M74.9654 162.62C73.3836 162.663 71.8019 162.837 70.2479 163.185C69.4728 163.355 68.6464 163.454 67.9267 163.893C67.2387 164.316 66.519 164.858 66.1789 165.685L66.2738 165.791C67.1003 165.582 67.7923 165.396 68.508 165.178C69.2119 164.969 69.8643 164.542 70.5682 164.265C71.9917 163.703 73.4746 163.209 74.9772 162.762L74.9574 162.62H74.9654Z",
  fill: "url(#paint9_linear_1_172)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M96.5399 161.406C94.4639 160.789 92.1586 160.089 89.877 160.932C88.7618 161.378 87.8326 162.312 87.3897 163.454C86.9231 164.593 86.9508 165.922 87.4332 167.073C87.9077 168.223 88.8607 169.247 90.1933 169.627C91.5536 169.991 93.0878 169.445 93.851 168.172C94.0448 167.844 94.1199 167.492 94.1792 167.171C94.2227 167.021 94.2227 166.827 94.2227 166.645C94.2306 166.464 94.2227 166.282 94.1594 166.096C93.9894 165.309 93.2737 164.732 92.6054 164.617C91.949 164.486 91.2886 164.566 90.7113 164.87C90.1261 165.178 89.7386 165.985 90.0826 166.531L90.2249 166.483C90.1617 165.918 90.5255 165.57 90.9723 165.463C91.4152 165.329 91.9292 165.38 92.3207 165.554C92.7161 165.748 92.9257 166.013 92.9494 166.345C92.9771 166.645 92.8545 167.171 92.645 167.452C92.2337 168.069 91.2965 168.437 90.5136 168.275C89.6753 168.12 88.8805 167.46 88.4495 166.618C88.0263 165.748 87.9314 164.712 88.2399 163.767C88.5404 162.83 89.2324 162.015 90.1656 161.576C92.0518 160.663 94.3848 161.086 96.5004 161.548L96.5399 161.406Z",
  fill: "url(#paint10_linear_1_172)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M94.9543 164.115C95.6225 164.625 96.2592 165.139 96.8681 165.657C97.1766 165.918 97.3901 166.286 97.7539 166.436C98.1137 166.594 98.4933 166.713 99.0549 166.725L99.1616 166.618C99.1339 166.052 98.8888 165.641 98.6001 165.301C98.3194 164.957 97.8448 164.862 97.4573 164.704C96.6625 164.364 95.844 164.123 95.0057 163.988L94.9543 164.115Z",
  fill: "url(#paint11_linear_1_172)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M95.5711 163.462C96.8365 163.877 98.0386 164.368 99.1893 164.902C99.7706 165.174 100.269 165.586 100.87 165.768C101.471 165.965 102.068 166.151 102.827 166.203L102.914 166.092C102.594 165.392 102.072 164.898 101.503 164.514C100.925 164.111 100.225 164.012 99.5729 163.846C98.2561 163.502 96.9235 163.336 95.5949 163.328L95.5672 163.458L95.5711 163.462Z",
  fill: "url(#paint12_linear_1_172)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M98.434 162.478C99.9287 162.948 101.396 163.462 102.807 164.059C103.511 164.348 104.156 164.783 104.856 165C105.572 165.242 106.26 165.439 107.078 165.661L107.185 165.558C106.845 164.728 106.153 164.166 105.461 163.727C104.761 163.284 103.93 163.174 103.151 162.988C101.597 162.608 100.032 162.418 98.4617 162.339L98.434 162.482V162.478Z",
  fill: "url(#paint13_linear_1_172)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6558 157.392L48.4123 157.207H61.1609H86.6779H112.203H124.959L137.716 157.392L124.959 157.586H112.203H86.6779H61.1609H48.4123L35.6558 157.392Z",
  fill: "url(#paint14_linear_1_172)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M51.6311 36.0038C51.5797 35.0982 51.2713 34.4537 50.7098 34.078C50.1443 33.6984 49.3693 33.5007 48.3767 33.5007C47.4356 33.5007 46.7159 33.7063 46.1979 34.0939C45.6839 34.4893 45.4506 35.118 45.4782 36.0038C45.4941 36.4506 45.6799 36.8263 46.0239 37.1308C46.3719 37.4352 46.7832 37.6883 47.2616 37.9018C47.7361 38.1075 48.2383 38.2814 48.7603 38.408C49.2823 38.5385 49.7172 38.6452 50.0454 38.7401C50.9114 39.0051 51.7023 39.3096 52.4061 39.6417C53.1179 39.966 53.7427 40.3614 54.2528 40.8122C54.7629 41.2748 55.1662 41.8087 55.447 42.4216C55.7357 43.0424 55.8859 43.7819 55.8859 44.6439C55.8859 45.7511 55.6843 46.6883 55.2888 47.4712C54.8934 48.2383 54.3556 48.8631 53.6636 49.3297C52.9756 49.8082 52.1808 50.1364 51.2713 50.342C50.3578 50.5358 49.3772 50.6188 48.353 50.5911C47.2814 50.5595 46.3047 50.4092 45.4268 50.1364C44.5569 49.8596 43.8016 49.4484 43.165 48.9027C42.5363 48.3609 42.0459 47.6808 41.6742 46.8504C41.3144 46.0239 41.1048 45.0472 41.0574 43.9124H44.8574C44.8891 45.0156 45.2291 45.8618 45.8816 46.4431C46.5222 47.0283 47.3763 47.3289 48.44 47.3407C49.6421 47.3684 50.5476 47.1707 51.1487 46.7792C51.7537 46.3917 52.0344 45.6641 51.9909 44.6083C51.9751 44.1101 51.8407 43.7067 51.6034 43.3864C51.3583 43.0622 51.0459 42.7893 50.6425 42.5679C50.2471 42.3385 49.7845 42.1487 49.2546 41.9866C48.7168 41.8284 48.1672 41.6545 47.5938 41.4844C46.9255 41.3025 46.2335 41.085 45.5217 40.8359C44.806 40.5749 44.1654 40.2467 43.5841 39.8355C42.9989 39.4282 42.5363 38.9181 42.1566 38.317C41.7731 37.7041 41.5872 36.9607 41.5872 36.0789C41.5872 35.122 41.7731 34.2678 42.1052 33.5324C42.4493 32.7889 42.9238 32.18 43.5288 31.6976C44.1219 31.1993 44.8376 30.8276 45.6799 30.5785C46.5064 30.3175 47.4158 30.191 48.3846 30.191C49.4997 30.191 50.4765 30.3254 51.3504 30.5983C52.2045 30.8672 52.936 31.2586 53.5489 31.7608C54.1381 32.263 54.6087 32.8799 54.929 33.5996C55.2572 34.3232 55.4391 35.122 55.4628 36.0038H51.6311Z",
  fill: "url(#paint15_linear_1_172)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M61.3547 43.9598V50.2392H57.4676V30.8118H64.8977C66.0445 30.8118 67.0291 31.0253 67.8358 31.4643C68.6504 31.8992 69.3028 32.441 69.805 33.0974C70.3151 33.7538 70.6789 34.4616 70.9122 35.2287C71.1455 35.9998 71.2602 36.7235 71.2602 37.3917C71.2602 38.06 71.1455 38.7876 70.9122 39.5587C70.6829 40.3179 70.3151 41.0376 69.809 41.6821C69.3068 42.3267 68.6583 42.8763 67.8437 43.3034C67.037 43.7344 66.0603 43.9558 64.9017 43.9558H61.3547V43.9598ZM63.7589 40.7133C64.9017 40.7133 65.7954 40.4484 66.4201 39.8829C67.0528 39.3333 67.3692 38.5029 67.3692 37.3957C67.3692 36.2885 67.0528 35.4818 66.4201 34.9243C65.7954 34.3627 64.9017 34.0859 63.7589 34.0859H61.3547V40.7133H63.7589Z",
  fill: "url(#paint16_linear_1_172)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8722 50.2392L76.2782 30.8118H80.1573L86.5751 50.2392H82.8225L81.6441 46.6487H74.7637L73.613 50.2392H69.8683H69.8722ZM78.2 36.0354L75.7799 43.4853H80.6121L78.2 36.0354Z",
  fill: "url(#paint17_linear_1_172)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M98.956 50.2392L95.5158 42.6391H92.0004V50.2392H88.0975V30.8118H96.1366C97.2912 30.8118 98.2442 30.9976 99.0311 31.3614C99.8101 31.7371 100.431 32.1998 100.909 32.7573C101.388 33.3188 101.732 33.9357 101.934 34.6198C102.135 35.2801 102.222 35.9207 102.222 36.5416C102.222 37.02 102.187 37.4827 102.1 37.9414C102.009 38.3961 101.854 38.839 101.617 39.2621C101.388 39.6813 101.072 40.0886 100.66 40.4682C100.257 40.8399 99.7469 41.1799 99.1221 41.4884L103.092 50.2392H98.9481H98.956ZM92.0004 39.3728H94.8238C95.3378 39.3728 95.8044 39.3293 96.2355 39.2621C96.6665 39.1909 97.0382 39.0525 97.3466 38.8548C97.6629 38.6531 97.8963 38.3882 98.0702 38.0323C98.2442 37.6962 98.3352 37.2454 98.3352 36.7076C98.3352 36.1699 98.2482 35.723 98.0702 35.379C97.8923 35.0468 97.6629 34.774 97.3466 34.5921C97.0382 34.3983 96.6665 34.2678 96.2355 34.2006C95.8044 34.1294 95.3378 34.0899 94.8238 34.0899H92.0004V39.3768V39.3728Z",
  fill: "url(#paint18_linear_1_172)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M107.885 34.0859H103.025V30.8118H116.632V34.0859H111.784V50.2392H107.889V34.0859H107.885Z",
  fill: "url(#paint19_linear_1_172)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M115.07 50.2392L121.488 30.8118H125.355L131.769 50.2392H128.028L126.85 46.6487H119.969L118.818 50.2392H115.07ZM123.405 36.0354L120.981 43.4853H125.814L123.405 36.0354Z",
  fill: "url(#paint20_linear_1_172)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M79.3862 82.0435H65.5858V80.355H80.8414V73.7316C80.8414 69.7101 79.9003 68.5475 74.7558 68.5475H46.973C41.8245 68.5475 40.8834 69.7101 40.8834 73.7316V75.1591C40.8834 79.1885 41.8245 80.355 46.973 80.355H56.1271V82.0435H42.3346C39.8552 82.0435 38.9695 83.2456 38.9695 84.5308C38.9695 85.8831 39.9066 86.9706 42.3346 86.9706H79.3823C81.8142 86.9706 82.7553 85.8831 82.7553 84.5308C82.7553 83.1784 81.8577 82.0435 79.3823 82.0435H79.3862ZM51.0894 75.5387C50.2471 75.5387 50.2036 75.3094 50.2036 74.6371V74.2299C50.2036 73.6328 50.2471 73.3639 51.0894 73.3639H70.6354C71.4816 73.3639 71.5212 73.6328 71.5212 74.2299V75.5427H51.0894V75.5387Z",
  fill: "#E4C680"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M79.6235 99.1221H51.2238C50.5279 99.1221 50.346 98.8571 50.346 98.4419C50.346 98.0702 50.5318 97.8053 51.2238 97.8053H80.8454V91.9727C80.8454 89.6872 79.58 88.4811 75.598 88.4811H43.4141C41.5477 88.4811 40.7568 89.6081 40.7568 90.5848C40.7568 91.5615 41.6861 92.6529 43.4141 92.6529H70.3072C71.0032 92.6529 71.2009 92.8427 71.2009 93.2579V93.9301H46.1781C42.1092 93.9301 40.2823 95.7768 40.2823 98.4064V98.521C40.2823 101.076 42.1566 103.325 46.1781 103.325H79.6235C81.4939 103.325 82.1463 102.123 82.1463 101.226C82.1463 100.174 81.4425 99.1221 79.6235 99.1221Z",
  fill: "#E4C680"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M115.963 78.2474V77.0809C115.963 70.9913 110.534 68.5436 102.586 68.5436C94.6379 68.5436 89.2008 70.9913 89.2008 77.0809V78.2474C89.2008 84.3489 94.634 86.7887 102.586 86.7887C110.538 86.7887 115.963 84.3489 115.963 78.2474ZM98.3747 78.5835V76.7448C98.3747 74.8665 100.107 73.9254 102.586 73.9254C105.065 73.9254 106.789 74.8665 106.789 76.7448V78.5835C106.789 80.5093 105.061 81.4069 102.586 81.4069C100.111 81.4069 98.3747 80.5053 98.3747 78.5835Z",
  fill: "#E4C680"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M126.3 88.2478C123.872 88.2478 121.903 89.1612 121.622 91.261H100.668C100.34 89.1889 98.4617 88.2478 96.0812 88.2478C93.4635 88.2478 91.3638 89.3115 91.3638 91.862V97.8448C91.3638 101.866 92.7596 103.325 98.003 103.325H130.938V91.866C130.938 89.3431 128.926 88.2517 126.304 88.2517L126.3 88.2478ZM121.578 98.3273H101.977C100.949 98.3273 100.712 98.2165 100.712 97.3901V96.0733H121.578V98.3273Z",
  fill: "#E4C680"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M130.693 71.7426C130.693 69.3265 128.411 68.0256 125.972 68.0256C123.532 68.0256 121.25 69.3028 121.25 71.7426V87.0852H130.697V71.7426H130.693Z",
  fill: "#E4C680"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M78.8287 126.177H62.5489V123.998C62.5489 121.59 60.208 120.72 57.7721 120.72C55.3363 120.72 53.0032 121.555 53.0032 123.998V126.177H42.904C40.0569 126.177 38.9774 127.617 38.9774 129.111C38.9774 130.606 40.1004 132.089 42.904 132.089H78.8287C81.6362 132.089 82.7592 130.65 82.7592 129.111C82.7592 127.573 81.6797 126.177 78.8287 126.177Z",
  fill: "#E4C680"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M71.9047 133.845H49.824C43.3666 133.845 40.2823 136.593 40.2823 140.618C40.2823 144.644 43.3666 147.321 49.824 147.321H71.9047C78.366 147.321 81.4425 144.675 81.4425 140.618C81.4425 136.561 78.366 133.845 71.9047 133.845ZM69.5717 141.935H52.1649C50.2906 141.935 49.7845 141.449 49.7845 140.618C49.7845 139.788 50.2906 139.381 52.1649 139.381H69.5717C71.4302 139.381 71.9522 139.792 71.9522 140.618C71.9522 141.445 71.4302 141.935 69.5717 141.935Z",
  fill: "#E4C680"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9642 118.435H69.7536C70.5919 118.435 70.928 118.767 70.928 119.261V119.783C70.928 121.784 70.5049 123.397 69.9434 124.742H79.1055C79.667 123.397 80.2285 121.025 80.2285 118.126V116.663C80.2285 113.959 78.4965 112.408 73.961 112.408H44.9642C41.8759 112.408 40.6619 113.761 40.6619 115.386C40.6619 117.118 41.9194 118.435 44.9642 118.435Z",
  fill: "#E4C680"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M115.07 120.159V118.166C115.07 114.789 113.342 113.085 108.249 113.085H93.9815C91.2214 113.085 90.1419 114.631 90.1419 116.098C90.1419 117.565 91.2649 119.111 93.9815 119.111H104.638C105.346 119.111 105.718 119.34 105.718 119.937V120.345C105.718 124.785 100.336 127.039 93.3646 126.929C91.1226 126.885 89.4815 127.834 89.3471 129.598C89.2008 131.591 90.9407 132.911 93.0404 133.014C104.789 133.734 115.07 129.21 115.07 120.155V120.159Z",
  fill: "#E4C680"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M127.095 141.374H102.586C101.554 141.374 101.317 141.267 101.317 140.433V138.246C101.317 135.723 99.2565 134.529 96.6427 134.529C94.029 134.529 91.8264 135.687 91.8264 138.246V141.718C91.8264 145.743 93.2223 147.202 98.4617 147.202H127.095C129.906 147.202 131.029 145.814 131.029 144.272C131.029 142.73 129.95 141.378 127.095 141.378V141.374Z",
  fill: "#E4C680"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M130.891 121.29H129.432V115.604C129.432 113.203 127.281 111.887 124.853 111.887C122.425 111.887 120.266 113.16 120.266 115.604V138.475H129.428V127.834H130.887C133.69 127.834 134.576 126.098 134.576 124.556C134.576 123.014 133.734 121.29 130.887 121.29H130.891Z",
  fill: "#E4C680"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M849.195 63.5826V56.5508C849.195 44.6359 843.098 38.6226 825.128 38.6226H774.79C765.051 38.6226 761.242 44.0778 761.242 49.254C761.242 54.4302 765.205 59.8854 774.79 59.8854H812.39C814.887 59.8854 816.199 60.6946 816.199 62.8013V64.2384C816.199 79.9064 797.21 87.859 772.613 87.4683C764.702 87.3149 758.912 90.6633 758.438 96.8859C757.922 103.918 764.061 108.578 771.469 108.94C812.92 111.48 849.195 95.5186 849.195 63.5687V63.5826Z",
  fill: "black"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M891.623 138.435H805.149C801.508 138.435 800.67 138.058 800.67 135.114V127.399C800.67 118.497 793.401 114.284 784.179 114.284C774.957 114.284 767.186 118.372 767.186 127.399V139.649C767.186 153.852 772.111 159 790.597 159H891.623C901.543 159 905.505 154.103 905.505 148.662C905.505 143.22 901.696 138.449 891.623 138.449V138.435Z",
  fill: "black"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M905.017 67.5729H899.869V47.51C899.869 39.0412 892.279 34.3952 883.712 34.3952C875.146 34.3952 867.528 38.8877 867.528 47.51V128.208H899.855V90.6634H905.003C914.895 90.6634 918.02 84.5384 918.02 79.0972C918.02 73.6559 915.048 67.5729 905.003 67.5729H905.017Z",
  fill: "black"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M723.221 81.5807H665.781V73.8931C665.781 65.3964 657.521 62.327 648.927 62.327C640.332 62.327 632.101 65.2708 632.101 73.8931V81.5807H596.467C586.422 81.5807 582.613 86.6592 582.613 91.933C582.613 97.2069 586.575 102.439 596.467 102.439H723.221C733.127 102.439 737.089 97.3604 737.089 91.933C737.089 86.5057 733.28 81.5807 723.221 81.5807Z",
  fill: "black"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M698.791 108.634H620.883C598.1 108.634 587.217 118.33 587.217 132.533C587.217 146.736 598.1 156.182 620.883 156.182H698.791C721.588 156.182 732.443 146.848 732.443 132.533C732.443 118.218 721.588 108.634 698.791 108.634ZM690.559 137.179H629.143C622.53 137.179 620.744 135.463 620.744 132.533C620.744 129.603 622.53 128.166 629.143 128.166H690.559C697.117 128.166 698.958 129.617 698.958 132.533C698.958 135.449 697.117 137.179 690.559 137.179Z",
  fill: "black"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M603.736 54.2628H691.201C694.159 54.2628 695.345 55.4347 695.345 57.1787V59.0204C695.345 66.0801 693.852 71.7725 691.871 76.5161H724.197C726.179 71.7725 728.16 63.4013 728.16 53.1745V48.0123C728.16 38.4692 722.049 33 706.046 33H603.736C592.84 33 588.557 37.7716 588.557 43.5058C588.557 49.6168 592.993 54.2628 603.736 54.2628Z",
  fill: "black"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M508.221 69.0658V64.9499C508.221 43.4639 489.065 34.8277 461.022 34.8277C432.978 34.8277 413.794 43.4639 413.794 64.9499V69.0658C413.794 90.5936 432.964 99.202 461.022 99.202C489.079 99.202 508.221 90.5936 508.221 69.0658ZM446.163 70.2517V63.764C446.163 57.1369 452.274 53.8163 461.022 53.8163C469.77 53.8163 475.853 57.1369 475.853 63.764V70.2517C475.853 77.0463 469.756 80.2134 461.022 80.2134C452.288 80.2134 446.163 77.0323 446.163 70.2517Z",
  fill: "black"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M544.692 104.35C536.125 104.35 529.177 107.573 528.186 114.982H454.255C453.097 107.671 446.47 104.35 438.071 104.35C428.835 104.35 421.426 108.103 421.426 117.102V138.212C421.426 152.401 426.351 157.549 444.852 157.549H561.057V117.116C561.057 108.215 553.956 104.364 544.706 104.364L544.692 104.35ZM528.033 139.914H458.873C455.246 139.914 454.409 139.523 454.409 136.607V131.961H528.033V139.914Z",
  fill: "black"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M560.192 46.1148C560.192 37.5902 552.142 33 543.534 33C534.925 33 526.875 37.5065 526.875 46.1148V100.248H560.206V46.1148H560.192Z",
  fill: "black"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M380.603 82.0132H331.911V76.0557H385.737V52.6862C385.737 38.4971 382.417 34.3952 364.265 34.3952H266.239C248.073 34.3952 244.753 38.4971 244.753 52.6862V57.7228C244.753 71.9399 248.073 76.0557 266.239 76.0557H298.537V82.0132H249.873C241.125 82.0132 238 86.2546 238 90.7889C238 95.5605 241.307 99.3973 249.873 99.3973H380.589C389.169 99.3973 392.49 95.5605 392.49 90.7889C392.49 86.0174 389.323 82.0132 380.589 82.0132H380.603ZM280.763 59.0622C277.791 59.0622 277.637 58.253 277.637 55.8812V54.4441C277.637 52.3374 277.791 51.3886 280.763 51.3886H349.727C352.713 51.3886 352.852 52.3374 352.852 54.4441V59.0762H280.763V59.0622Z",
  fill: "black"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M381.44 142.272H281.237C278.782 142.272 278.14 141.337 278.14 139.872C278.14 138.56 278.795 137.626 281.237 137.626H385.751V117.046C385.751 108.982 381.286 104.727 367.237 104.727H253.682C247.097 104.727 244.306 108.703 244.306 112.149C244.306 115.595 247.585 119.446 253.682 119.446H348.569C351.025 119.446 351.722 120.116 351.722 121.581V123.953H263.434C249.078 123.953 242.632 130.468 242.632 139.746V140.151C242.632 149.164 249.245 157.103 263.434 157.103H381.44C388.039 157.103 390.341 152.861 390.341 149.694C390.341 145.983 387.858 142.272 381.44 142.272Z",
  fill: "black"
});

var _ref46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1_172",
  x1: 86.5,
  y1: 231.903,
  x2: 86.5,
  y2: -55.9611,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1_172",
  x1: 86.496,
  y1: 225.592,
  x2: 86.496,
  y2: -48.5745,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6D4021"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#784C25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#936830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#9E7334"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#90642D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#885B2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#9A7442"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#CCB883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#ECE3AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#F8F4BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#F6EEB4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#F2E0A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1DFA3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1_172",
  x1: 3.75262,
  y1: 99.3831,
  x2: 169.243,
  y2: 99.3831,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6D4021"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#784C25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#936830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#9E7334"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#90642D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#885B2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#9A7442"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#CCB883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#ECE3AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#F8F4BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#F6EEB4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#F2E0A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1DFA3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_1_172",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-12.5232 -16.8374) scale(175.851 175.851)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#1A1A1A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#040000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1_172",
  x1: 84.4477,
  y1: 70.4654,
  x2: 88.924,
  y2: 49.3653,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1_172",
  x1: 80.0167,
  y1: 138.706,
  x2: 86.6966,
  y2: 170.17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1_172",
  x1: 76.5131,
  y1: 139.428,
  x2: 83.198,
  y2: 170.909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_1_172",
  x1: 70.9816,
  y1: 140.601,
  x2: 77.6665,
  y2: 172.082,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_1_172",
  x1: 69.0449,
  y1: 141.086,
  x2: 75.7107,
  y2: 172.476,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_1_172",
  x1: 65.812,
  y1: 141.751,
  x2: 72.4825,
  y2: 173.164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_1_172",
  x1: 86.2339,
  y1: 137.37,
  x2: 92.9161,
  y2: 168.848,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_1_172",
  x1: 90.9016,
  y1: 136.331,
  x2: 97.5988,
  y2: 167.86,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_1_172",
  x1: 93.1122,
  y1: 135.932,
  x2: 99.7896,
  y2: 167.387,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_1_172",
  x1: 96.6764,
  y1: 135.159,
  x2: 103.359,
  y2: 166.631,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_1_172",
  x1: 84.4477,
  y1: 146.842,
  x2: 88.9239,
  y2: 167.942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCB551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#F8F6CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#DECBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B1884B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#FDFBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#D8C378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#D5BE7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ECE8C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4D8A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_1_172",
  x1: -12.626,
  y1: 40.393,
  x2: 167.496,
  y2: 40.393,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FFFCD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#FAF3BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#EEDD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#DBBA4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CB9B0C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#E7CD67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3E18B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFCD1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_1_172",
  x1: -12.6142,
  y1: 40.5275,
  x2: 167.464,
  y2: 40.5275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FFFCD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#FAF3BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#EEDD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#DBBA4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CB9B0C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#E7CD67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3E18B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFCD1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_1_172",
  x1: -12.63,
  y1: 40.5275,
  x2: 167.504,
  y2: 40.5275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FFFCD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#FAF3BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#EEDD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#DBBA4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CB9B0C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#E7CD67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3E18B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFCD1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_1_172",
  x1: -12.6498,
  y1: 40.5275,
  x2: 167.504,
  y2: 40.5275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FFFCD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#FAF3BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#EEDD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#DBBA4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CB9B0C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#E7CD67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3E18B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFCD1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_1_172",
  x1: -12.6616,
  y1: 40.5275,
  x2: 167.508,
  y2: 40.5275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FFFCD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#FAF3BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#EEDD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#DBBA4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CB9B0C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#E7CD67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3E18B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFCD1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_1_172",
  x1: -12.5984,
  y1: 40.5275,
  x2: 167.488,
  y2: 40.5275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FFFCD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#FAF3BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#EEDD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#DBBA4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CB9B0C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#E7CD67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3E18B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFCD1"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 919,
    viewBox: "0 0 919 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.25
  }, _ref2), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0792118b.svg";
export { ForwardRef as ReactComponent };